var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Catalogs", {
    attrs: {
      title: "Группы заявок",
      "create-text": "Новая группа",
      "fetch-data": _vm.fetchData,
      fields: _vm.fields,
      "route-create": "TaskGroupAdd",
      "route-edit": "TaskGroupEdit",
      "route-view": "TaskGroupView",
      "route-path": "/task_groups",
      "can-edit": _vm.canEditTaskGroups()
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-07a8a02a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// /home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07a8a02a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!/home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Catalogs/TaskGroups/TaskGroups.vue
// module id = null
// module chunks = 